<template>
  <el-dialog
    top="0"
    class="dialog-full-medium"
    width="30%"
    title="编辑IP信息"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :before-close="handleClose"
    @open="handleOpen"
  >
    <div class="dialog__body">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="服务商名称" prop="remark">
          <el-input v-model.trim="form.remark" :size="formSize" />
        </el-form-item>
        <el-form-item label="MAC地址" prop="macAddress">
          <el-input v-model.trim="form.macAddress" :size="formSize" />
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose()" :size="formSize" :loading="submitLoading">取消</el-button>
      <el-button
        type="primary"
        :size="formSize"
        @click="submit()"
        :loading="submitLoading"
      >
        保存
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { setIpProxyConfigEditRemark } from '@/api/service-ip';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isModify: {
      type: Boolean,
      default: false,
    },
    currentObj: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      title: '',
      submitLoading: false,
      form: {
        eipInstanceId: '',
        macAddress: '',
        remark: '',
      },
      rules: {
        remark: [{ required: true, message: '请输入', trigger: 'blur' }],
        macAddress: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      options: [
        { label: '易宝', value: 3 },
        { label: '易票联', value: 4 },
      ],
    };
  },
  methods: {
    // 关闭
    handleClose() {
      this.$emit('update:visible', false);
      this.submitLoading = false;
    },
    // 打开窗口前
    handleOpen() {
      this.$nextTick(async () => {
        const { ipId, macAddress, remark } = this.currentObj;
        this.form = {
          eipInstanceId: ipId || '',
          macAddress,
          remark,
        };
        this.$refs.form.resetFields();
      });
    },
    // 提交
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            this.submitLoading = true;
            await setIpProxyConfigEditRemark(this.form);
            this.$message.success(`${this.isModify ? '编辑' : '新增'}成功！！`);
            this.submitLoading = false;
            this.handleClose();
            this.$emit('success');
          } catch (error) {
            console.log(error);
            this.submitLoading = false;
          }
        }
      });
    },
  },

};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-dialog {
    min-width: 500px;
  }
  .content {
    margin-right: 0;
  }
}
</style>
